import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

const routeNames: Record<string, string> = {
  "": "Strona główna",
  produkty: "Produkty",
  zamowienie: "Zamówienie",
  "o-nas": "O nas",
  blog: "Blog",
  "baza-wiedzy": "Baza wiedzy",
  kontakt: "Kontakt",
  "polityka-prywatnosci": "Polityka prywatności",
  "polityka-cookies": "Polityka cookies",
  "naklejki-doming": "Naklejki doming",
  "naklejki-wypukle": "Naklejki wypukłe 3D",
  "naklejki-z-logo": "Naklejki z logo firmy",
  kalkulator: "Kalkulator wyceny",
  "zastosowania-branzowe": "Zastosowania branżowe naklejek 3D",
  realizacje: "Przykładowe realizacje",
  "naklejki-wypukle-3d": "Naklejki wypukłe 3D",
  "naklejki-plaskie": "Naklejki płaskie",
  "identyfikatory-3d": "Identyfikatory 3D",
  "zalewanie-zywica-na-materiale-klienta": "Zalewanie żywicą na materiale klienta",
  "breloki-domingowe": "Breloki domingowe",
  "magnesy-reklamowe": "Magnesy reklamowe 3D",
};

interface BreadcrumbsProps {
  articleTitle?: string;
}

const Breadcrumbs = ({ articleTitle }: BreadcrumbsProps) => {
  const { pathname } = useLocation();
  const isEn = pathname === "/en" || pathname.startsWith("/en/");
  const segments = pathname.split("/").filter(Boolean).filter((seg, i) => !(isEn && i === 0));

  if (segments.length === 0) return null;

  const crumbs = segments.map((seg, i) => {
    const path = (isEn ? "/en/" : "/") + segments.slice(0, i + 1).join("/");
    const isLast = i === segments.length - 1;
    const name =
      isLast && articleTitle
        ? articleTitle
        : routeNames[seg] || seg.replace(/-/g, " ");
    return { name, path, isLast };
  });

  // JSON-LD BreadcrumbList
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Strona główna",
        item: "https://www.naklejki-3d.com.pl/",
      },
      ...crumbs.map((c, i) => ({
        "@type": "ListItem",
        position: i + 2,
        name: c.name,
        item: `https://www.naklejki-3d.com.pl${c.path}`,
      })),
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <nav aria-label="Breadcrumb" className="py-3 px-4">
        <ol className="container mx-auto flex items-center gap-1 text-sm text-muted-foreground flex-wrap">
          <li>
            <Link
              to="/"
              className="hover:text-accent transition-colors flex items-center gap-1"
            >
              <Home className="w-3.5 h-3.5" />
              <span className="sr-only">Strona główna</span>
            </Link>
          </li>
          {crumbs.map((c) => (
            <li key={c.path} className="flex items-center gap-1">
              <ChevronRight className="w-3.5 h-3.5 text-muted-foreground/50" />
              {c.isLast ? (
                <span className="text-foreground font-medium truncate max-w-[200px]">
                  {c.name}
                </span>
              ) : (
                <Link
                  to={c.path}
                  className="hover:text-accent transition-colors"
                >
                  {c.name}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumbs;
